import React, { useState } from 'react'
import { siteUrl } from '../../../utils/siteUrl'

// temporal logo
import Logo from '../../../assets/images/v-confident.webp'

import './header.scss'
import Button from '../../atoms/button/button'
import { graphql, useStaticQuery } from 'gatsby'
import { encryptUserInfo } from '../../../utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'

const Header = ({ isMobile }) => {
  const { allContentfulVConfidentTransversal } = useStaticQuery(
    graphql`
      query header {
        allContentfulVConfidentTransversal {
          nodes {
            node_locale
            pais
            tieneSolicitudDeMuestra
            menuSuperior {
              tituloComponente
              redireccionComponente
              referenciasComponentes {
                tituloComponente
                redireccionComponente
              }
            }
          }
        }
      }
    `
  )


  const contentInfo = allContentfulVConfidentTransversal.nodes.filter(
    e => e.node_locale === 'es-CO' &&  process.env.LOCALE.includes(e.pais)
  )[0]

  const haveSample = contentInfo.tieneSolicitudDeMuestra
  const headerInfo = contentInfo.menuSuperior

  const [activeMenu, setActiveMenu] = useState(false)

  const redirectionsample = () => {
    localStorage.setItem('openModalLogin',true)
    window.location.href = siteUrl + '/muestra-gratis'
  }

  const dataLayerMenu = (option, subCategory) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Menu_VConfident',
      category: 'v-confident',
      action: 'click',
      label: option,
      sub_category: subCategory,
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }
  // const currentLocation = typeof window !== "undefined" ? window.location.pathname.split("/")[1] : ""

  return (
    <header className="f-header">
      <div className="f-header__wrapper">
        <nav className={`f-header__menu ${activeMenu ? 'active' : ''}`}>
          {isMobile && (
            <div className="f-header__buttons ">
              {haveSample && (
                <Button
                  text="Quiero mi kit gratis"
                  color="purple"
                  type="icon--bag"
                  action={() => {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'ga_event',
                      category: 'V-Confident :: Menú',
                      action: 'Click',
                      label: `Solicita una muestra`,
                      value: '',
                    })
                    redirectionsample()
                  }}
                />
              )}

              {/*<Button text="Comprar" color="purple" type="icon--cart" />*/}
            </div>
          )}
          {headerInfo.map((item, i) => {
            if (item.referenciasComponentes) {
              return (
                <div className="f-header__dropdown" key={`itemMenu-${i + 1}`}>
                  <span className="f-header__dropdown-item">
                    {item.tituloComponente}
                  </span>
                  <div className="f-header__sub-menu">
                    {item.referenciasComponentes.map((subitem, y) => {
                      return (
                        <a
                          onClick={e => {
                            dataLayerMenu(subitem.tituloComponente , item.tituloComponente)
                            window.dataLayer = window.dataLayer || []
                            window.dataLayer.push({
                              event: 'ga_event',
                              category: 'V-Confident :: Menú',
                              action: 'Click',
                              label: `${subitem.tituloComponente}`,
                              value: '',
                            })
                          }}
                          href={siteUrl + '/' + subitem.redireccionComponente}
                          key={`SubitemMenu-${y + 1}`}
                          className="f-header__sub-menu-item"
                        >
                          {subitem.tituloComponente}
                        </a>
                      )
                    })}
                  </div>
                </div>
              )
            } else {
              return (
                <a
                  onClick={e => {
                    dataLayerMenu( item.tituloComponente, 'ninguno')
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'ga_event',
                      category: 'V-Confident :: Menú',
                      action: 'Click',
                      label: `${item.tituloComponente}`,
                      value: '',
                    })
                  }}
                  href={siteUrl + '/' + item.redireccionComponente}
                  key={`itemMenu-${i + 1}`}
                  className="f-header__menu-item"
                >
                  {item.tituloComponente}
                </a>
              )
            }
          })}
        </nav>

        <a className="f-header__logo" href={siteUrl} onClick={()=>dataLayerMenu('Home', 'ninguno')}>
          <img src={Logo} alt="Logo V-Confident" />
        </a>

        <div
          className="f-header__btn-menu-mob"
          onClick={() => setActiveMenu(!activeMenu)}
        >
          <span />
        </div>
        <div className="f-header__buttons desktop">
          {/*<Button text="Comprar" color="purple" type="icon--cart" />*/}
          {haveSample && (
            <Button
              text="Quiero mi kit gratis"
              color="white"
              type="icon--bag"
              action={() => {
                dataLayerMenu('Solicita una muestra', 'ninguno')
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'ga_event',
                  category: 'V-Confident :: Menú',
                  action: 'Click',
                  label: `Solicita una muestra`,
                  value: '',
                })
                redirectionsample()
              }}
            />
          )}
        </div>
      </div>
      {/* <script
        type="text/javascript"
        src="https://cdn-ukwest.onetrust.com/consent/a18bbff7-da96-4623-a8a2-7590db0a3046/OtAutoBlock.js"
      ></script>
      <script
        src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
        data-document-language="true"
        type="text/javascript"
        charset="UTF-8"
        data-domain-script="a18bbff7-da96-4623-a8a2-7590db0a3046"
      ></script> */}
    </header>
  )
}

export default Header
